import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { BoardInlineInput } from './BoardInlineInput'
import { Col, Row, Card } from 'react-bootstrap'
import { useContext } from './Context'
import { TextAreaInlineInput } from '@ztechapps/webui.input'
import { DeleteBoardButton } from './DeleteBoardButton'
import { BoardItemProduct } from './BoardItemProduct'
import { EmptyContent } from '../EmptyContent'
import { ShowIf } from '@ztechapps/webui.util'

export const BoardItem = () => {
  const { document } = useContext()
  const hasItems = !isEmpty(document?.items)

  return (
    <div>
      <Card className="pb-4">
        <Card.Header>
          <div className="d-flex justify-content-between ">
            <div className="w-75">
              <BoardInlineInput
                name="name"
                validate={async (e) => {
                  if (isEmpty(e)) throw new Error('Name cannot be empty.')
                }}
                displayContent={(e) => <h5>{e}</h5>}
              />
              <BoardInlineInput
                name="remarks"
                validate={async (e) => {
                  if (isEmpty(e)) throw new Error('Remarks cannot be empty.')
                }}
                parentInputComponent={TextAreaInlineInput}
                inputProps={{ rows: 4 }}
              />
            </div>
            <div>
              <DeleteBoardButton />
            </div>
          </div>
        </Card.Header>

        <Card.Body>
          <ShowIf condition={!hasItems}>
            <EmptyContent message="You do not have products for this favorites list yet!" />
          </ShowIf>

          <ShowIf condition={hasItems}>
            <Row className="g-2">
              {map(document?.items, ({ _id, entity: product }) => (
                <Col xl={12} key={_id}>
                  <BoardItemProduct product={product} board={document} boardItemId={_id} />
                </Col>
              ))}
            </Row>
          </ShowIf>
        </Card.Body>
      </Card>
    </div>
  )
}
